export default __webpack_public_path__ + "static/bulkVp1-806b1823fd63d28476a71faea468db95.png";